import { render, staticRenderFns } from "./CareInfo.vue?vue&type=template&id=6a0a746d&scoped=true&"
import script from "./CareInfo.vue?vue&type=script&lang=js&"
export * from "./CareInfo.vue?vue&type=script&lang=js&"
import style0 from "./CareInfo.vue?vue&type=style&index=0&id=6a0a746d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0a746d",
  null
  
)

export default component.exports